function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3320"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 41304",
  d: "M51.243 8.793A29.82 29.82 0 0030.022 0h-.006A30.017 30.017 0 000 30.017a30.017 30.017 0 0030.017 30.016h.006a30.017 30.017 0 0030.01-30.016 29.82 29.82 0 00-8.79-21.224zM10.746 30.017a19.293 19.293 0 0119.271-19.271h.005a19.142 19.142 0 019.286 2.384l-9.291 9.294-1.317 1.317-15.57 15.566a19.142 19.142 0 01-2.384-9.29zm19.275 19.27a19.141 19.141 0 01-9.291-2.38l9.286-9.286 1.328-1.328L46.908 20.73a19.141 19.141 0 012.38 9.286 19.294 19.294 0 01-19.267 19.271z",
  fill: "#f0663c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 41305",
  d: "M51.244 8.793A29.82 29.82 0 0030.023 0h-.006v10.746h.005a19.142 19.142 0 019.288 2.384l-9.293 9.294v15.2l1.328-1.328L46.908 20.73a19.278 19.278 0 01-16.891 28.557v10.746h.006a30.017 30.017 0 0030.011-30.016 29.82 29.82 0 00-8.79-21.224z",
  fill: "#f0483c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 41306",
  d: "M46.907 20.73L31.344 36.292l-1.328 1.328-9.286 9.286a19.142 19.142 0 009.286 2.38 19.278 19.278 0 0016.886-28.557z",
  fill: "#dee7ed"
}));

function SvgDangerIcon(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.033,
    height: 60.033,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerIcon);
export default __webpack_public_path__ + "static/media/danger-icon.f2d0a17d.svg";
export { ForwardRef as ReactComponent };